<template>
	<fragment>
		<common-header
			subname="상담관리"
			name="상담글 상세 보기"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
		></common-header>

		<section ref="container" class="container">
			<nav class="side-nav"></nav>

			<section ref="container" class="container-fiuld class-making-box clearfix" v-if="article">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">
						온라인상담
					</div>
				</div>
				<div class="white-box m-t-10 clearfix">
					<p class="f-18 m-b-15 m-t-10 text-bold text-blue">상담자 설문</p>
					<template  v-if="articleSurveyList.length">
						<div class="input-group full-width">
							<table cellpadding="0" cellspacing="0" border="0">
								<tr v-for="(articleSurvey,idx) in articleSurveyList" :key="'counsel-survey-for-'+articleSurvey.surveyItemId+'-'+idx">
									<td style="width:100px"><b>{{articleSurvey.itemName}}</b></td>
									<template v-if="article.counselSurvey[articleSurvey.surveyItemId]">
										<td v-for="(counselId,cidx) in Object.keys(article.counselSurvey[articleSurvey.surveyItemId])" :key="'counsel-surveyItem-for-'+counselId+'-'+cidx">
											<template v-if="cidx">| (복수 응답) </template>
											<template v-if="articleSurvey.surveyItemId != counselId">{{article.counselSurvey[articleSurvey.surveyItemId][counselId].itemName}}</template>
											<template v-if="article.counselSurvey[articleSurvey.surveyItemId][counselId].etcText">
												<template v-if="article.counselSurvey[articleSurvey.surveyItemId][counselId].type === '작성보기'">: </template>
												{{article.counselSurvey[articleSurvey.surveyItemId][counselId].etcText}}
											</template>
										</td>
									</template>
									<template  v-else><td>답변 없음</td></template>
								</tr>
							</table>
						</div>
					</template>
					<template v-else>
						설문지가 존재 하지 않습니다.
					</template>

				</div>
				<div class="white-box m-t-10 clearfix">
					<p class="f-18 m-b-15 m-t-10 text-bold text-blue">상담제목: {{article.title}}</p>
					<div class="input-group full-width">
						<span class="input-group-addon text-left">
							<b>분류 :</b> {{article.articleCategoryNm}}
						</span>
						<span class="input-group-addon text-left">
							<b>작성자 :</b> {{article.mber && article.mber.mberName || article.name}}
						</span>
						<span class="input-group-addon text-left">
							<b>작성일 :</b> {{article.regDate}}
						</span>
						<span class="input-group-addon text-left">
							<b>조회 :</b> {{ article.lookupCount }}
						</span>
					</div>

					<div class="on-border round p-15 m-t-5 m-b-10" v-html="`${article.content.replaceAll('\n', '<br/>' || '')}`"></div>
					<ul class="m-b-10" v-if="article.articleFileMappingList.length > 0">
						<li v-for="file in article.articleFileMappingList" :key="`article-file-${hash(file)}`">
							<a class="down-btn" :href="'/download/'+file.atchFileId" target="_blank">{{file.file.orignlFileNm}}</a>
						</li>
					</ul>
					<div class="btn-group pull-right m-t-30 clearfix">
						<button class="btn btn-darkgray round m-r-5" type="button" @click="$router.push(`/counsel${`?offset=${parseInt(offset)}`}${`&pageSize=${parseInt(pageSize)}`}${keyword && `&keyword=${keyword}` || ''}`)">목록</button>
						<button class="btn btn-red round" type="button" @click="deleteArticle" v-if="counselDelete">삭제</button>
					</div>
				</div>
				<div class="white-box m-t-10 clearfix" v-if="hostParentName!=='mom_home'">
					<textarea class="full-width" cols="30" rows="2" v-model="newComment"></textarea>
					<button class="btn-sm round pull-right" @click="postComment">댓글달기</button>
				</div>
				<div class="white-box m-t-10 clearfix" v-if="article.commentList && article.commentList.length">
					<div class="comment" v-for="comment in article.commentList" :key="`comment-${hash(comment)}`">
						<p class="m-b-0 clearfix">
							{{comment.mberId}} ｜ {{comment.regDate}}
							<span class="pull-right" v-if="!modifyingComment || modifyingComment.commentId!=comment.commentId">
								<a class="modify" @click="modifyComment(comment)"></a>
								<a class="del" @click="deleteComment(comment)"></a>
							</span>
							<span class="pull-right" v-if="modifyingComment && modifyingComment.commentId==comment.commentId">
								<button class="btn-sm round pull-right" @click="modifyCommentConfirm">수정완료</button>
								<button class="btn-sm round pull-right" @click="modifyCommentCancel">취소</button>
							</span>
						</p>
						<div v-if="!modifyingComment || modifyingComment.commentId!=comment.commentId" class="bg-lightgray p-15" style="line-height: 1.4;" v-html="comment.content ? comment.content.replace(/\n/g, '<br>') : ''"></div>
						<textarea v-if="modifyingComment && modifyingComment.commentId==comment.commentId" class="full-width" cols="30" rows="2" v-model="modifyingComment.content"></textarea>
					</div>
				</div>

				<div class="title-box m-b-30 m-t-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">
						답글쓰기
					</div>
				</div>
				<div class="white-box m-t-10 clearfix" v-if="reply.regDate">
					<div class="input-group full-width">
						<span class="input-group-addon text-left">
							<b>작성자 :</b> {{reply.mber && reply.mber.mberName || reply.name}} {{reply.mberId && `(${reply.mberId})`|| ""}}
						</span>
						<span class="input-group-addon text-left">
							<b>작성일 :</b> {{reply.regDate}}
						</span>
					</div>
				</div>
				<div class="input-group full-width">
					<span class="input-group-addon">
						<!-- <input class="form-control round m-b-0" type="text" placeholder="제목을 입력하세요." v-model="reply.title" disabled> -->
					</span>
				</div>
				<!-- <div class="input-group full-width m-t-10">
					<span class="input-group-addon bg-white on-border round v-mid text-left p-5">
						<span class="text-darkgray" v-for="(fileName, idx) in articleFileNames" :key="`article-file-${fileName}`">
							{{fileName}}<a @click="articleFileMappingList.splice(idx, 1); articleFileNames.splice(idx, 1)" class="f-16 m-l-5 m-r-10 text-blue text-bold">×</a>
						</span>
					</span>
					<span class="input-group-addon w40 v-mid p-l-5">
						<input id="file" type="file" style="display: none;" ref="fileRef" @change="fileUpload">
						<label for="file" class="btn btn-darkgray f-14 round full-width">+</label>
					</span>
				</div> -->
				<div class="input-group full-width m-t-10 bg-white">
					<textarea class="full-width editorContent" cols="30" rows="4"></textarea>
				</div>

				<div class="white-box m-t-10 clearfix" v-if="replySurveyList.length">
					<div class="col-md-6 m-t-5">
						<div class="input-group full-width">
							<span class="input-group-addon label not bg-blue v-mid text-white round">고충 분류</span>
							<button class="btn btn-blue round m-l-5" type="button" @click="surveyModalOpen">고충 분류 선택</button>
						</div>
					</div>
							
					<div class="col-md-6 m-t-5" v-for="(replySurvey,idx) in replySurveyList" :key="'counsel-replySurveyList-for-write-'+replySurvey.surveyItemId+'-'+idx">
						<div class="input-group full-width" v-if="replySurvey.itemName.indexOf('고충 분류') === -1">
							<span class="input-group-addon label not bg-blue v-mid text-white round">{{replySurvey.itemName}}</span>
							<template v-if="reply.counselSurvey[replySurvey.surveyItemId]">
								<div v-for="(counselId,cidx) in Object.keys(reply.counselSurvey[replySurvey.surveyItemId])" :key="'counsel-replySurvey-for-'+replySurveyList.surveyItemId+'-'+cidx">
									<input 
										v-if="replySurvey.type=='주관식'"
										class="form-control full-width round m-l-5"
										type="text"
										ref="counselAnswer"
										surveyType="주관식"
										:surveyItemId="replySurvey.surveyItemId"
										:value="[
											reply.counselSurvey && 
											reply.counselSurvey[replySurvey.surveyItemId] && 
											reply.counselSurvey[replySurvey.surveyItemId][counselId].etcText || ''
										]"
									>
									<select 
										v-else-if="replySurvey.type=='객관식'"
										class="form-control full-width round m-l-5"
										ref="counselAnswer" 
										surveyType="객관식"
										:surveyItemId="replySurvey.surveyItemId"
										:value="[
											reply.counselSurvey &&
											reply.counselSurvey[replySurvey.surveyItemId] &&
											reply.counselSurvey[replySurvey.surveyItemId][counselId].surveyItemId || ''
										]" 
									>
										<option value="">{{replySurvey.itemName}} 선택</option>
										<option v-for="(childItem,childIdx) in replySurvey.child" :key="'counsel-replySurveyList-for-write-'+replySurveyList.surveyId+'-child-'+childItem.surveyItemId+'-'+childIdx" :value="childItem.surveyItemId">
											{{childItem.itemName}}
										</option>
									</select>
								</div>
							</template>
							<template v-else>
								<input 
									v-if="replySurvey.type=='주관식'"
									class="form-control full-width round m-l-5"
									type="text"
									ref="counselAnswer"
									surveyType="주관식"
									:surveyItemId="replySurvey.surveyItemId"
								>
								<select 
									v-else-if="replySurvey.type=='객관식'"
									class="form-control full-width round m-l-5"
									ref="counselAnswer" 
									surveyType="객관식"
									:surveyItemId="replySurvey.surveyItemId"
								>
									<option value="">{{replySurvey.itemName}} 선택</option>
									<option v-for="(childItem,childIdx) in replySurvey.child" :key="'counsel-replySurveyList-for-write-'+replySurveyList.surveyId+'-child-'+childItem.surveyItemId+'-'+childIdx" :value="childItem.surveyItemId">
										{{childItem.itemName}}
									</option>
								</select>
							</template>
						</div>
					</div>
				</div>
				<button class="btn btn-blue round m-t-30 m-b-30 pull-right" type="button" @click="writeReply" v-if="!reply.articleId && counselReplyCreate">답변작성</button>
				<button class="btn btn-blue round m-t-30 m-b-30 pull-right" type="button" @click="writeReply" v-if="reply.articleId && counselReplyUpdate">답변수정</button>
			</section>

		</section>

		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
		<modal-counsel-survey-hard-select :config="modals.ModalCounselSurveyHardSelect" @close="modals.ModalCounselSurveyHardSelect.show=false;"></modal-counsel-survey-hard-select>

		<common-footer></common-footer>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import ModalCounselSurveyHardSelect from '../modals/ModalCounselSurveyHardSelect.vue'

import Axios from 'axios'
import server from '../statics/server'

export default {
	// 컴포넌트 명
	name: 'ViewCounselDetail',
	mixins: [fnAdjustHeight],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		CommonHeader,
		CommonFooter,
		ModalConfirm,
		ModalAlert,
		ModalCounselSurveyHardSelect
	},
	mounted: async function() {
		await this.getArtcle();
		await this.getReplyArticle();
		this.getUser();
		this.getAuthInfo().then((auth) => {
			if(auth['관리자 권한']['상담관리: 상담 등록'] && auth['관리자 권한']['상담관리: 상담 등록']['permission']) {
				this.counselReplyCreate = true;
			}
			if(auth['관리자 권한']['상담관리: 상담 수정'] && auth['관리자 권한']['상담관리: 상담 수정']['permission']) {
				this.counselReplyUpdate = true;
			}
			if(auth['관리자 권한']['상담관리: 상담 삭제'] && auth['관리자 권한']['상담관리: 상담 삭제']['permission']) {
				this.counselDelete = true;
			}
			if(auth['관리자 메뉴']['상담관리']) {
				if(auth['관리자 메뉴']['상담관리']['상담글 목록'] && auth['관리자 메뉴']['상담관리']['상담글 목록']['enabled']) {
					this.menus = [
						...this.menus,
						{name:'상담글 목록',link:"/counsel",selected:true}
					];
				}
				if(auth['관리자 메뉴']['상담관리']['상담 통계'] && auth['관리자 메뉴']['상담관리']['상담 통계']['enabled']) {
					this.menus = [
						...this.menus,
						{name:"상담통계", link:"/counselStatistics",selected:false}
					];
				}
			}
		});
	},
	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			menus : [],
			buttons : [],
			sideButtons: [],
			sideMenus: [],

			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
				ModalCounselSurveyHardSelect: ModalCounselSurveyHardSelect.default(),
			},
			counselDelete : false,
			counselReplyCreate : false,
			counselReplyUpdate : false,
			newComment: "",
			modifyingComment: null,
			mberName: "",
			mobileNum: "",
			articleSurveyList:{},
			replySurveyList: {},
			surveyItemList: [],
			article: null,
			reply: {articleId:0,parentsId:this.$route.params.articleId,title:"",content:""},
			category: {id: 645, value: ""},
			category2: {id: 580, value: ""},
			category3: {id: 597, value: ""},
			eventListenerCount: 0,
			articleCategoryId: 0,
			articleFileNames: [],
			articleFileMappingList: [],
			title: "",
			content: "",
			editorContent: null,
			keyword: this.$route.query.keyword || "",
			pageSize: this.$route.query.pageSize || 30,
			offset: this.$route.query.offset || 0,
			isWriteReplyAble: true,
			hostParentName: server.hostParentName
		}
	},
	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		getUser: function() {
			Axios.post(server.addr()+server.api.AUTHORIZATION).then((response) => {
				this.mberName = response.data.return.mberName;
				this.mobileNum = response.data.return.mobileNum;
			});
		},
		editorInit: function() {
			let that = this;
			window.tinymce.init({
				selector: '.editorContent',
				height: 500,
				branding: false,
				plugins: [
					"autoresize",
					"advlist autolink lists link image charmap print preview anchor",
					"searchreplace visualblocks code fullscreen",
					"insertdatetime media table paste imagetools wordcount lineheight addfile"
				],
				content_style: "body {margin: 40px 2rem !important; line-height: 1.5; width:866px;} body > p {margin: 0}",
				toolbar_mode: 'wrap',
				toolbar: "| insertfile undo redo | styleselect fontselect fontsizeselect lineheight| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image addfile",
				fontsize_formats: "8pt 10pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 30pt 32pt 34pt 36pt 38pt 40pt",
				lineheight_formats: "1 1.5 2 2.5 3 3.5 4 4.5 5",
				images_upload_handler: function(blobInfo, success) {
					const formData = new FormData();
					formData.append('file', blobInfo.blob(), blobInfo.filename());
					Axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
						success("/download/" + response.data);
					});
				},
				files_upload_handler: function(fileObj, success) {
					const formData = new FormData();
					formData.append('file', fileObj);
					Axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
						success("/download/" + response.data);
					});
				},
				setup: function(editor) {
					editor.on('init', function() {
						editor.setContent(that.reply.content);
					});
					editor.on("change", function() {
						that.reply.content = editor.getContent();
					})
				}
			}).then((r) => {this.editorContent = r[0]});
		},
		surveyAnswer: async function({surveyId, surveyApplId}) {
			const { data } = await Axios.post(`${server.addr()}${server.api.SURVEY_APPL}/${surveyApplId}`);
			const surveyItemApplList =  data.return.surveyItemApplList || [];
			const counselSurvey = {};
			const response = await Axios.post(server.addr()+server.api.SURVEY+"/"+surveyId)
				.then((response) => response.data.return.surveyItemMappingList)
				.then((questionList) => { // 설문답안을 순회하면서
					surveyItemApplList.some(surveyItemAppl => { // 이 답안이 어떤 문항에 대한건지 찾는다.
						let surveyChild = ""; // 객관식 답
						const suerveyParent = questionList.find(e => { 
							if(e.surveyItemId==surveyItemAppl.surveyItemId) return e; // survey parentsId:0 search (주관식)
							else { // if empty, search survey child search (객관식)
								const child = e.child.find(c => c.surveyItemId==surveyItemAppl.surveyItemId);
								if(child) {
									surveyChild = child;
									return e;
								}
							}
						});
						if(!suerveyParent) return false;
						counselSurvey[suerveyParent.surveyItemId] = counselSurvey[suerveyParent.surveyItemId] || {};
						const surveySelect = surveyChild || suerveyParent;
						counselSurvey[suerveyParent.surveyItemId][surveySelect.surveyItemId] = Object.assign({ itemName:surveySelect.itemName, type:surveySelect.type },surveyItemAppl);
					});
					return {counselSurvey,questionList};
				});
			return response;
		},
		getArtcle: async function() {
			const { articleId } = this.$route.params;
			try {
				const { data: articleData } = await Axios.post(`${server.addr()}${server.api.ARTICLE}/${articleId}`);
				const { surveyId } = articleData.return.surveyAppl || {};
				this.article = articleData.return ? articleData.return : {};
				this.$set(this.article, "counselSurvey", {});
				if(surveyId) {
					this.surveyAnswer({
						surveyId: surveyId,
						surveyApplId: this.article.surveyApplId
					}).then(({counselSurvey,questionList})=> {
						this.article.counselSurvey = counselSurvey;
						this.articleSurveyList = questionList;
					});
				}
			} catch(e) { e }
		},
		getReplyArticle: async function() {
			try {
				// 답변 불러오기
				const { data: articleReData } = await Axios.post(`${server.addr()}${server.api.ARTICLE}`, this.reply);
				this.reply = parseInt(articleReData.filtered) && articleReData.list[0] || this.reply;
				// if(this.reply.articleFileMappingList && this.reply.articleFileMappingList.length) {
				// 	this.articleFileMappingList = this.reply.articleFileMappingList;
				// 	this.articleFileNames = this.reply.articleFileMappingList.map(e => e.file.orignlFileNm);
				// }
				if(server.counselReplySurveyId) {
					this.$set(this.reply, "counselSurvey", {});
					const { data : replySurveyList } = await Axios.post(`${server.addr()}${server.api.SURVEY}/${server.counselReplySurveyId}`);
					this.replySurveyList = replySurveyList.return.surveyItemMappingList;
					if(this.reply.surveyApplId) {
						this.surveyAnswer({
							surveyId: server.counselReplySurveyId,
							surveyApplId: this.reply.surveyApplId
						}).then(({counselSurvey})=> {
							this.reply.counselSurvey = counselSurvey;
							if(counselSurvey[this.category.id]) this.category.value = counselSurvey[this.category.id][Object.keys(counselSurvey[this.category.id])[0]].surveyItemId;
							if(counselSurvey[this.category2.id]) this.category2.value = counselSurvey[this.category2.id][Object.keys(counselSurvey[this.category2.id])[0]].surveyItemId;
							if(counselSurvey[this.category3.id]) this.category3.value = counselSurvey[this.category3.id][Object.keys(counselSurvey[this.category3.id])[0]].etcText;
						});
					}
				}
				this.editorInit();

			} catch(e) { e }
		},
		deleteArticle: function() {
			this.modals.ModalConfirm.msg = "상담글을 정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "삭제";
			this.modals.ModalConfirm.btnYes.fn = () => {
				Axios.delete(`${server.addr()}${server.api.ARTICLE}/${this.$route.params.articleId}`)
				.then(() => {
					this.modals.ModalConfirm.show = false;
					this.$router.push("/counsel/"+server.counselBoardId);
				})
			}
			this.modals.ModalConfirm.show = true;
		},
		postComment: async function() {
			try {
				if(this.newComment) {
					await Axios.put(`${server.addr()}${server.api.COMMENT}`, [{
						articleId: this.article.articleId,
						content: this.newComment
					}]);
					this.newComment = "";
					this.getArtcle();
				}
			} catch(e) { e }
		},
		modifyComment: function(comment) {
			this.modifyingComment = JSON.parse(JSON.stringify(comment));
		},
		modifyCommentCancel: function() {
			this.modifyingComment = null;
		},
		modifyCommentConfirm: function() {
			Axios.patch(server.addr()+server.api.COMMENT+"/"+this.modifyingComment.commentId, this.modifyingComment).then( () => {
				this.modifyingComment = null;
				this.getArtcle();
			})
		},
		deleteComment: function(comment) {
			this.modals.ModalConfirm.msg = "댓글을 정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "삭제";
			this.modals.ModalConfirm.btnYes.fn = () => {
				Axios.delete(server.addr()+server.api.COMMENT+"/"+comment.commentId).then( () => {
					this.getArtcle();
					this.modals.ModalConfirm.show = false;
				})
			}
			this.modals.ModalConfirm.show = true;
		},
		onDone: function(message) {
			this.modals.ModalAlert.msg = message;
			this.modals.ModalAlert.show = true;
		},
		fileUpload: async function() {
			const formData = new FormData();
			formData.append("file", this.$refs.fileRef.files[0]);
			try {
				const { data } = await Axios.post(`${server.addr()}${server.api.FILE}`, formData);
				this.articleFileNames.push(this.$refs.fileRef.files[0].name);
				this.articleFileMappingList.push({atchFileId:data});
			} catch(e) {
				//TODO: error exception
			}
		},
		writeReply: function() {
			if(!this.isWriteReplyAble) return;
			else this.isWriteReplyAble = false;
			const { mberName, mobileNum, reply } = this;
			const { title, content } = this.reply;
			const boardId = server.counselBoardId;
			let surveyAppl = {};
			if(server.counselReplySurveyId) {
				surveyAppl =  { surveyApplId: reply && reply.surveyApplId || "", surveyId: server.counselReplySurveyId, mberName, mobileNum, surveyItemApplList: [] };
				this.$refs.counselAnswer.forEach(answer => {
					if(answer.getAttribute("surveyType")==="주관식" && answer.value)
						surveyAppl.surveyItemApplList.push({surveyItemId:answer.getAttribute("surveyItemId"), etcText:answer.value});
					else if(answer.value)
						surveyAppl.surveyItemApplList.push({surveyItemId:answer.value});
				});

				if(this.category.value) surveyAppl.surveyItemApplList.push({surveyItemId:this.category.value});
				if(this.category2.value) surveyAppl.surveyItemApplList.push({surveyItemId:this.category2.value});
				if(this.category3.value) surveyAppl.surveyItemApplList.push({surveyItemId: this.category3.id ,etcText: this.category3.value});
				if(!surveyAppl.surveyItemApplList.length) surveyAppl = null;
			}

			if(this.reply.articleId) {
				Axios.patch(`${server.addr()}${server.api.ARTICLE}/${this.reply.articleId}`, {
					title, content, parentsId:this.article.articleId, boardId, surveyAppl
				}).then(() => {
					this.modals.ModalAlert.msg = "답글이 수정 되었습니다.";
					this.modals.ModalAlert.show = true;
					this.getReplyArticle();
					this.isWriteReplyAble = true;
				}).catch(() => {
					this.modals.ModalAlert.msg = "답글을 수정할 수 없습니다.";
					this.modals.ModalAlert.show = true;
				});
			}
			else {
				Axios.put(`${server.addr()}${server.api.ARTICLE}`, [{
					title, content, parentsId:this.article.articleId, boardId, surveyAppl
				}]).then(() => {
					this.modals.ModalAlert.msg = "답글이 작성 되었습니다.";
					this.modals.ModalAlert.show = true;
					this.getReplyArticle();
					this.isWriteReplyAble = true;
				}).catch(() => {
					this.modals.ModalAlert.msg = "답글을 작성할 수 없습니다.";
					this.modals.ModalAlert.show = true;
				});
			}
		},
		surveyModalOpen: function() {
			this.modals.ModalCounselSurveyHardSelect.category =  parseInt(this.category.value);
      this.modals.ModalCounselSurveyHardSelect.category2 = parseInt(this.category2.value);
			this.modals.ModalCounselSurveyHardSelect.category3 = this.category3.value;
			this.modals.ModalCounselSurveyHardSelect.show = true;
			this.modals.ModalCounselSurveyHardSelect.finish = ({category, category2, category3}) => {
				this.category.value = category;
				this.category2.value = category2;
				this.category3.value = category3;
				this.modals.ModalCounselSurveyHardSelect.show = false;
			}
		}
	}
}
</script>
<style scope>
	tr {height: 50px;}

	.recycle {
		fill: #fff;
		fill-rule: evenodd;
	}

	.btn-group .btn:hover .recycle {
		fill: #fff;
		fill-rule: evenodd;
	}
</style>
